const VARIANT = {
  symbol: 'symbol',
  wordmark: 'wordmark',
  'wordmark-dark': 'wordmark-dark',
  logo: 'logo',
  'logo-dark': 'logo-dark',
} as const;

type Variant = (typeof VARIANT)[keyof typeof VARIANT];

export type LogotypeProps = {
  variant: Variant;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
} & React.HTMLAttributes<HTMLImageElement>;

// No helpers imports: this sits in the embed SPA's eager entry (via
// AttributionFooter), where `@/helpers/general` transitively drags the whole
// helpers barrel into the first-paint chunk.
const Logotype = ({ variant, className = '', ...props }: LogotypeProps) => {
  return (
    <img src={`/images/logotypes/${variant}.svg`} {...props} className={className} alt={props?.alt ?? 'Bokadirekt'} />
  );
};

export default Logotype;
